export const initialState = {
  actionProcessing: false,
  agentsRanking: [],
  rubyPlayRanking: {
    agentsRanking: [],
    myRank: null,
    withRanking: false,
  },
  pragmaticSlotsRanking: {
    agentsRanking: [],
    myRank: null,
    withRanking: false,
  },
  pragmaticLiveRanking: {
    agentsRanking: [],
    myRank: null,
    withRanking: false,
  },
  myRank: null,
  withRanking: false,
};

export default initialState;
